module.exports = __webpack_public_path__ + "static/media/test12_1.9e0c7280.png";